import { getFirestore } from "firebase/firestore";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/analytics";
import axios from "axios";

const firebaseConfig = {
  apiKey: "AIzaSyAlH3B2y8pIhxibslrHayl9WJ5KrMQqm0s",
  authDomain: "torsera-e9c75.firebaseapp.com",
  projectId: "torsera-e9c75",
  storageBucket: "torsera-e9c75.appspot.com",
  messagingSenderId: "419416288804",
  appId: "1:419416288804:web:90c3ac27ed0bc0a37732b1",
  measurementId: "G-MWCHHS8W3L",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
export const db = getFirestore(firebaseApp);
const analytics = firebase.analytics();

export async function handleSubscribe(userData, priceId) {
  if (!userData || !userData.user_id) {
    console.error("User data or user ID is missing");
    // Handle this error, maybe show a message to the user
    return;
  }

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/create-checkout-session`,
      {
        price_id: priceId,
        user_id: userData.user_id,
        base_url: process.env.REACT_APP_BASE_URL,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );

    if (response.status === 200) {
      window.location.href = response.data.url;
    } else {
      console.error("Failed to create checkout session");
      console.error("Error details:", response.data);
      // Handle this error, maybe show a message to the user
    }
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    );
    // Handle this error, maybe show a message to the user
  }
}
